const getters = {
  getDataEditPartner: (state) => state.dataPartner,
  getDataEditProductCategory: (state) => state.editProductCategory,
  getDataIsComingFromCreatePartner: (state) => state.isComingFromCreatePartner,
  getListProductCategoriesByOrganization: (state) =>
    state.listProductCategoriesByOrganization,
  getPartnerProducts: (state) => state.partnerProducts,
  getPartnerDetail: (state) => state.dataPartner,
};

export default getters;
